export const ACTION_RESET = 'FETCH_PRESSDATALISTBYIDS_RESET';
export const ACTION_REQUEST = 'FETCH_PRESSDATALISTBYIDS_REQUEST';
export const ACTION_SUCCESS = 'FETCH_PRESSDATALISTBYIDS_SUCCESS';
export const ACTION_ERROR = 'FETCH_PRESSDATALISTBYIDS_ERROR';
